var dt = Object.defineProperty;
var ht = (e, t, n) => t in e ? dt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var P = (e, t, n) => (ht(e, typeof t != "symbol" ? t + "" : t, n), n), Re = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
};
var ve = (e, t, n) => (Re(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Te = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, Ce = (e, t, n, r) => (Re(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
import yt, { useReducer as pt, createContext as Fe, useContext as St, createElement as gt, useState as mt, useEffect as Et } from "react";
import { ZodError as _t } from "zod";
const F = "Skywatch/Core";
window[F] || (window[F] = {
  baseUrl: "",
  gtmId: ""
});
const X = () => window[F], tr = (e) => {
  const t = window[F];
  window[F] = {
    ...t,
    ...e
  };
}, nr = (e) => e == null || !(Object.keys(e) || e).length, rr = (e, t) => Object.fromEntries(Object.entries(t).filter(([n]) => !e.includes(n))), je = (e, t, n) => {
  const r = (s) => String.prototype.split.call(t, s).filter(Boolean).reduce((c, i) => c != null ? c[i] : c, e), o = r(/[,[\]]+?/) || r(/[,[\].]+?/);
  return o === void 0 || o === e ? n : o;
}, wt = (e) => typeof e == "function", de = function(e, t) {
  if (typeof e == "function")
    return function() {
      return e(arguments) ? t.apply(this, arguments) : (n) => t(n, ...arguments);
    };
  switch (e) {
    case 0:
    case 1:
      throw new RangeError(`Invalid arity ${e}`);
    case 2:
      return function(n, r) {
        return arguments.length >= 2 ? t(n, r) : function(o) {
          return t(o, n);
        };
      };
    case 3:
      return function(n, r, o) {
        return arguments.length >= 3 ? t(n, r, o) : function(s) {
          return t(s, n, r);
        };
      };
    case 4:
      return function(n, r, o, s) {
        return arguments.length >= 4 ? t(n, r, o, s) : function(c) {
          return t(c, n, r, o);
        };
      };
    case 5:
      return function(n, r, o, s, c) {
        return arguments.length >= 5 ? t(n, r, o, s, c) : function(i) {
          return t(i, n, r, o, s);
        };
      };
    default:
      return function() {
        if (arguments.length >= e)
          return t.apply(this, arguments);
        const n = arguments;
        return function(r) {
          return t(r, ...n);
        };
      };
  }
};
function L(e, t, n, r, o, s, c, i, u) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return t(e);
    case 3:
      return n(t(e));
    case 4:
      return r(n(t(e)));
    case 5:
      return o(r(n(t(e))));
    case 6:
      return s(o(r(n(t(e)))));
    case 7:
      return c(s(o(r(n(t(e))))));
    case 8:
      return i(c(s(o(r(n(t(e)))))));
    case 9:
      return u(i(c(s(o(r(n(t(e))))))));
    default: {
      let f = arguments[0];
      for (let l = 1; l < arguments.length; l++)
        f = arguments[l](f);
      return f;
    }
  }
}
let Ot = "3.2.5";
const qe = () => Ot, oe = /* @__PURE__ */ Symbol.for(`effect/GlobalValue/globalStoreId/${/* @__PURE__ */ qe()}`);
oe in globalThis || (globalThis[oe] = /* @__PURE__ */ new Map());
const Q = globalThis[oe], he = (e, t) => (Q.has(e) || Q.set(e, t()), Q.get(e)), Je = wt, bt = (e) => typeof e == "object" && e !== null, Rt = (e) => bt(e) || Je(e), J = /* @__PURE__ */ de(2, (e, t) => Rt(e) && t in e), I = (e) => e == null;
class ye {
  constructor(t) {
    P(this, "self");
    P(this, "called", !1);
    this.self = t;
  }
  /**
   * @since 2.0.0
   */
  next(t) {
    return this.called ? {
      value: t,
      done: !0
    } : (this.called = !0, {
      value: this.self,
      done: !1
    });
  }
  /**
   * @since 2.0.0
   */
  return(t) {
    return {
      value: t,
      done: !0
    };
  }
  /**
   * @since 2.0.0
   */
  throw(t) {
    throw t;
  }
  /**
   * @since 2.0.0
   */
  [Symbol.iterator]() {
    return new ye(this.self);
  }
}
const vt = 335903614, Tt = 4150755663, Ct = 1481765933, jt = 1284865837, Nt = 9007199254740992, Mt = 134217728;
class Pt {
  constructor(t, n, r, o) {
    P(this, "_state");
    return I(n) && I(t) ? (n = Math.random() * 4294967295 >>> 0, t = 0) : I(n) && (n = t, t = 0), I(o) && I(r) ? (o = this._state ? this._state[3] : Tt, r = this._state ? this._state[2] : vt) : I(o) && (o = r, r = 0), this._state = new Int32Array([0, 0, r >>> 0, ((o || 0) | 1) >>> 0]), this._next(), Ne(this._state, this._state[0], this._state[1], t >>> 0, n >>> 0), this._next(), this;
  }
  /**
   * Returns a copy of the internal state of this random number generator as a
   * JavaScript Array.
   *
   * @category getters
   * @since 2.0.0
   */
  getState() {
    return [this._state[0], this._state[1], this._state[2], this._state[3]];
  }
  /**
   * Restore state previously retrieved using `getState()`.
   *
   * @since 2.0.0
   */
  setState(t) {
    this._state[0] = t[0], this._state[1] = t[1], this._state[2] = t[2], this._state[3] = t[3] | 1;
  }
  /**
   * Get a uniformly distributed 32 bit integer between [0, max).
   *
   * @category getter
   * @since 2.0.0
   */
  integer(t) {
    if (!t)
      return this._next();
    if (t = t >>> 0, !(t & t - 1))
      return this._next() & t - 1;
    let n = 0;
    const r = (-t >>> 0) % t >>> 0;
    for (n = this._next(); n < r; n = this._next())
      ;
    return n % t;
  }
  /**
   * Get a uniformly distributed IEEE-754 double between 0.0 and 1.0, with
   * 53 bits of precision (every bit of the mantissa is randomized).
   *
   * @category getters
   * @since 2.0.0
   */
  number() {
    const t = (this._next() & 67108863) * 1, n = (this._next() & 134217727) * 1;
    return (t * Mt + n) / Nt;
  }
  /** @internal */
  _next() {
    const t = this._state[0] >>> 0, n = this._state[1] >>> 0;
    It(this._state, t, n, Ct, jt), Ne(this._state, this._state[0], this._state[1], this._state[2], this._state[3]);
    let r = t >>> 18, o = (n >>> 18 | t << 14) >>> 0;
    r = (r ^ t) >>> 0, o = (o ^ n) >>> 0;
    const s = (o >>> 27 | r << 5) >>> 0, c = t >>> 27, i = (-c >>> 0 & 31) >>> 0;
    return (s >>> c | s << i) >>> 0;
  }
}
function It(e, t, n, r, o) {
  let s = (n >>> 16) * (o & 65535) >>> 0, c = (n & 65535) * (o >>> 16) >>> 0, i = (n & 65535) * (o & 65535) >>> 0, u = (n >>> 16) * (o >>> 16) + ((c >>> 16) + (s >>> 16)) >>> 0;
  c = c << 16 >>> 0, i = i + c >>> 0, i >>> 0 < c >>> 0 && (u = u + 1 >>> 0), s = s << 16 >>> 0, i = i + s >>> 0, i >>> 0 < s >>> 0 && (u = u + 1 >>> 0), u = u + Math.imul(n, r) >>> 0, u = u + Math.imul(t, o) >>> 0, e[0] = u, e[1] = i;
}
function Ne(e, t, n, r, o) {
  let s = t + r >>> 0;
  const c = n + o >>> 0;
  c >>> 0 < n >>> 0 && (s = s + 1 | 0), e[0] = s, e[1] = c;
}
const $t = /* @__PURE__ */ Symbol.for("effect/Utils/YieldWrap");
var q;
class Dt {
  constructor(t) {
    /**
     * @since 3.0.6
     */
    Te(this, q, void 0);
    Ce(this, q, t);
  }
  /**
   * @since 3.0.6
   */
  [$t]() {
    return ve(this, q);
  }
}
q = new WeakMap();
const g = /* @__PURE__ */ he("effect/Utils/isStructuralRegion", () => ({
  enabled: !1,
  tester: void 0
})), K = /* @__PURE__ */ he(/* @__PURE__ */ Symbol.for("effect/Hash/randomHashCache"), () => /* @__PURE__ */ new WeakMap()), At = /* @__PURE__ */ he(/* @__PURE__ */ Symbol.for("effect/Hash/pcgr"), () => new Pt()), R = /* @__PURE__ */ Symbol.for("effect/Hash"), v = (e) => {
  if (g.enabled === !0)
    return 0;
  switch (typeof e) {
    case "number":
      return Be(e);
    case "bigint":
      return $(e.toString(10));
    case "boolean":
      return $(String(e));
    case "symbol":
      return $(String(e));
    case "string":
      return $(e);
    case "undefined":
      return $("undefined");
    case "function":
    case "object":
      return e === null ? $("null") : kt(e) ? e[R]() : Ue(e);
    default:
      throw new Error(`BUG: unhandled typeof ${typeof e} - please report an issue at https://github.com/Effect-TS/effect/issues`);
  }
}, Ue = (e) => (K.has(e) || K.set(e, Be(At.integer(Number.MAX_SAFE_INTEGER))), K.get(e)), pe = (e) => (t) => t * 53 ^ e, Ve = (e) => e & 3221225471 | e >>> 1 & 1073741824, kt = (e) => J(e, R), Be = (e) => {
  if (e !== e || e === 1 / 0)
    return 0;
  let t = e | 0;
  for (t !== e && (t ^= e * 4294967295); e > 4294967295; )
    t ^= e /= 4294967295;
  return Ve(e);
}, $ = (e) => {
  let t = 5381, n = e.length;
  for (; n; )
    t = t * 33 ^ e.charCodeAt(--n);
  return Ve(t);
}, Le = function() {
  if (arguments.length === 1) {
    const n = arguments[0];
    return function(r) {
      return Object.defineProperty(n, R, {
        value() {
          return r;
        },
        enumerable: !1
      }), r;
    };
  }
  const e = arguments[0], t = arguments[1];
  return Object.defineProperty(e, R, {
    value() {
      return t;
    },
    enumerable: !1
  }), t;
}, M = /* @__PURE__ */ Symbol.for("effect/Equal");
function Se() {
  return arguments.length === 1 ? (e) => G(e, arguments[0]) : G(arguments[0], arguments[1]);
}
function G(e, t) {
  if (e === t)
    return !0;
  const n = typeof e;
  if (n !== typeof t)
    return !1;
  if (n === "object" || n === "function") {
    if (e !== null && t !== null && Me(e) && Me(t))
      return v(e) === v(t) && e[M](t) ? !0 : g.enabled && g.tester ? g.tester(e, t) : !1;
    if (g.enabled) {
      if (Array.isArray(e) && Array.isArray(t))
        return e.length === t.length && e.every((r, o) => G(r, t[o]));
      if (Object.getPrototypeOf(e) === Object.prototype && Object.getPrototypeOf(e) === Object.prototype) {
        const r = Object.keys(e), o = Object.keys(t);
        if (r.length === o.length) {
          for (const s of r)
            if (!(s in t && G(e[s], t[s])))
              return g.tester ? g.tester(e, t) : !1;
          return !0;
        }
      }
      return g.tester ? g.tester(e, t) : !1;
    }
  }
  return g.enabled && g.tester ? g.tester(e, t) : !1;
}
const Me = (e) => J(e, M), Ge = /* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom"), H = (e) => J(e, "toJSON") && Je(e.toJSON) && e.toJSON.length === 0 ? e.toJSON() : Array.isArray(e) ? e.map(H) : e, We = (e) => JSON.stringify(e, null, 2), xt = (e, t) => {
  switch (t.length) {
    case 1:
      return t[0](e);
    case 2:
      return t[1](t[0](e));
    case 3:
      return t[2](t[1](t[0](e)));
    case 4:
      return t[3](t[2](t[1](t[0](e))));
    case 5:
      return t[4](t[3](t[2](t[1](t[0](e)))));
    case 6:
      return t[5](t[4](t[3](t[2](t[1](t[0](e))))));
    case 7:
      return t[6](t[5](t[4](t[3](t[2](t[1](t[0](e)))))));
    case 8:
      return t[7](t[6](t[5](t[4](t[3](t[2](t[1](t[0](e))))))));
    case 9:
      return t[8](t[7](t[6](t[5](t[4](t[3](t[2](t[1](t[0](e)))))))));
    default: {
      let n = e;
      for (let r = 0, o = t.length; r < o; r++)
        n = t[r](n);
      return n;
    }
  }
}, Ft = /* @__PURE__ */ Symbol.for("effect/Effect"), qt = /* @__PURE__ */ Symbol.for("effect/Stream"), Jt = /* @__PURE__ */ Symbol.for("effect/Sink"), Ut = /* @__PURE__ */ Symbol.for("effect/Channel"), Pe = {
  /* c8 ignore next */
  _R: (e) => e,
  /* c8 ignore next */
  _E: (e) => e,
  /* c8 ignore next */
  _A: (e) => e,
  _V: /* @__PURE__ */ qe()
}, Vt = {
  /* c8 ignore next */
  _A: (e) => e,
  /* c8 ignore next */
  _In: (e) => e,
  /* c8 ignore next */
  _L: (e) => e,
  /* c8 ignore next */
  _E: (e) => e,
  /* c8 ignore next */
  _R: (e) => e
}, Bt = {
  /* c8 ignore next */
  _Env: (e) => e,
  /* c8 ignore next */
  _InErr: (e) => e,
  /* c8 ignore next */
  _InElem: (e) => e,
  /* c8 ignore next */
  _InDone: (e) => e,
  /* c8 ignore next */
  _OutErr: (e) => e,
  /* c8 ignore next */
  _OutElem: (e) => e,
  /* c8 ignore next */
  _OutDone: (e) => e
}, He = {
  [Ft]: Pe,
  [qt]: Pe,
  [Jt]: Vt,
  [Ut]: Bt,
  [M](e) {
    return this === e;
  },
  [R]() {
    return Le(this, Ue(this));
  },
  [Symbol.iterator]() {
    return new ye(new Dt(this));
  },
  pipe() {
    return xt(this, arguments);
  }
}, ze = /* @__PURE__ */ Symbol.for("effect/Option"), Ye = {
  ...He,
  [ze]: {
    _A: (e) => e
  },
  [Ge]() {
    return this.toJSON();
  },
  toString() {
    return We(this.toJSON());
  }
}, Lt = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(Ye), {
  _tag: "Some",
  _op: "Some",
  [M](e) {
    return Ze(e) && Ht(e) && Se(this.value, e.value);
  },
  [R]() {
    return Le(this, pe(v(this._tag))(v(this.value)));
  },
  toJSON() {
    return {
      _id: "Option",
      _tag: this._tag,
      value: H(this.value)
    };
  }
}), Gt = /* @__PURE__ */ v("None"), Wt = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(Ye), {
  _tag: "None",
  _op: "None",
  [M](e) {
    return Ze(e) && Xe(e);
  },
  [R]() {
    return Gt;
  },
  toJSON() {
    return {
      _id: "Option",
      _tag: this._tag
    };
  }
}), Ze = (e) => J(e, ze), Xe = (e) => e._tag === "None", Ht = (e) => e._tag === "Some", zt = /* @__PURE__ */ Object.create(Wt), Yt = (e) => {
  const t = Object.create(Lt);
  return t.value = e, t;
}, Qe = /* @__PURE__ */ Symbol.for("effect/Either"), Ke = {
  ...He,
  [Qe]: {
    _R: (e) => e
  },
  [Ge]() {
    return this.toJSON();
  },
  toString() {
    return We(this.toJSON());
  }
}, Zt = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(Ke), {
  _tag: "Right",
  _op: "Right",
  [M](e) {
    return et(e) && Kt(e) && Se(this.right, e.right);
  },
  [R]() {
    return pe(v(this._tag))(v(this.right));
  },
  toJSON() {
    return {
      _id: "Either",
      _tag: this._tag,
      right: H(this.right)
    };
  }
}), Xt = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(Ke), {
  _tag: "Left",
  _op: "Left",
  [M](e) {
    return et(e) && Qt(e) && Se(this.left, e.left);
  },
  [R]() {
    return pe(v(this._tag))(v(this.left));
  },
  toJSON() {
    return {
      _id: "Either",
      _tag: this._tag,
      left: H(this.left)
    };
  }
}), et = (e) => J(e, Qe), Qt = (e) => e._tag === "Left", Kt = (e) => e._tag === "Right", en = (e) => {
  const t = Object.create(Xt);
  return t.left = e, t;
}, tn = (e) => {
  const t = Object.create(Zt);
  return t.right = e, t;
}, z = () => zt, Y = Yt, tt = Xe, nt = /* @__PURE__ */ de(2, (e, {
  onNone: t,
  onSome: n
}) => tt(e) ? t() : n(e.value)), nn = /* @__PURE__ */ de(2, (e, t) => tt(e) ? t() : e.value), rn = (e) => e == null ? z() : Y(e), W = "id", on = (e, t) => e && typeof e == "object" && t in e, or = (e, t) => on(e, t) ? Y(e) : z(), ge = (e, t, n) => {
  const [r, o] = pt(t, e), s = (c) => {
    if (n && n(c, r), typeof c == "function")
      return c(s, r);
    o(c);
  };
  return [r, s];
}, sr = (e) => (...t) => e(...t), ee = tn, D = en, sn = (e, t, n) => (console.debug("middleware", n), t), cr = (e, t) => (localStorage.setItem(`@store:${e}`, JSON.stringify(t)), t), ir = (...e) => (t, n, r) => e.reduce((o, s) => s(t, n, r), n), rt = (e, t, n = sn) => (r, o) => L(
  o,
  // remove prefix from action type
  ({ type: s, payload: c }) => ({ type: s, payload: c, unprefixedAction: s.replace(`${e}/`, "") }),
  // run reducer function only if the action type is prefixed by the store's name
  ({ type: s, payload: c, unprefixedAction: i }) => s.startsWith(e) ? L(
    t(r),
    (u) => Array.isArray(c) ? i in u ? n(e, u[i](...c), o) : r : i in u ? n(e, u[i](c), o) : r
  ) : r
), cn = (e) => e.reduce(
  (t, n) => ({
    ...t,
    [n[W]]: n
  }),
  {}
), ot = (e) => ({
  status: "idle",
  error: null,
  ...e
}), ur = (e) => ({
  status: "idle",
  entities: {},
  keys: [],
  selected: null,
  error: null,
  ...e || {}
}), un = (e) => ({
  ...e,
  status: "busy"
}), an = (e, t) => ({ ...e, status: "idle", error: t.payload }), ln = (e, t) => {
  const n = t.payload, r = cn(t.payload);
  return {
    ...e,
    entities: {
      ...e.entities,
      ...r
    },
    keys: n.length ? Array.from(/* @__PURE__ */ new Set([...e.keys, ...n.map((o) => o[W])])) : e.keys,
    status: "idle",
    error: null
  };
}, fn = (e, t) => ({ ...e, meta: t.payload }), Ie = (e, t) => ({
  ...e,
  entities: {
    ...e.entities,
    [t.payload[W]]: t.payload
  },
  keys: Array.from(/* @__PURE__ */ new Set([...e.keys, t.payload[W]])),
  status: "idle"
}), dn = (e, t) => {
  const [n, r] = t.payload, s = { ...e.entities[n], ...r };
  return {
    ...e,
    status: "idle",
    entities: {
      ...e.entities,
      [n]: s
    }
  };
}, hn = (e, t) => {
  const n = t.payload;
  if (n in e.entities) {
    const { [n]: r, ...o } = e.entities;
    return {
      ...e,
      status: "idle",
      entities: o,
      keys: e.keys.filter((s) => s !== n),
      selected: e.selected === n ? null : e.selected
    };
  }
  return e;
}, yn = (e, t) => ({
  ...e,
  selected: t.payload
}), st = (e) => ({
  RequestStart: `${e} Request Start`,
  RequestError: `${e}  Request Error`,
  FetchCollectionSuccess: `Fetch ${e} List Success`,
  FetchModelByIdSuccess: `Fetch ${e} ByID Success`,
  CreateModelSuccess: `Create ${e} Model`,
  UpdateModelSuccess: `Update ${e} Model`,
  DeleteModelSuccess: `Delete ${e} Model`,
  SelectModel: `Select ${e} Model`,
  UpdateMeta: `Update ${e} Meta data`,
  Reset: `Reset ${e} State`,
  ClearError: `Clear ${e} error`
}), pn = (e, t, n) => {
  const r = st(e);
  return (o, s) => {
    switch (s.type) {
      case r.RequestStart:
        return { ...un(o), ...n && n(o, s) };
      case r.FetchCollectionSuccess:
        return {
          ...ln(o, s),
          ...n && n(o, s)
        };
      case r.FetchModelByIdSuccess:
        return {
          ...Ie(o, s),
          ...n && n(o, s)
        };
      case r.CreateModelSuccess:
        return {
          ...Ie(o, s),
          ...n && n(o, s)
        };
      case r.UpdateModelSuccess:
        return {
          ...dn(o, s),
          ...n && n(o, s)
        };
      case r.DeleteModelSuccess:
        return {
          ...hn(o, s),
          ...n && n(o, s)
        };
      case r.UpdateMeta:
        return {
          ...fn(o, s),
          ...n && n(o, s)
        };
      case r.RequestError:
        return { ...an(o, s), ...n && n(o, s) };
      case r.SelectModel:
        return { ...yn(o, s), ...n && n(o, s) };
      case r.Reset:
        return { ...t };
      case r.ClearError:
        return { ...o, error: null };
      default:
        return { ...o, ...n && n(o, s) };
    }
  };
}, ct = (e, t, n, r) => Object.entries(t(n)).reduce(
  (o, [s, c]) => ({
    ...o,
    [s]: async (...i) => r({ type: `${e}/${s}`, payload: i })
  }),
  {}
), it = (e, t) => Object.entries(e).reduce(
  (n, [r, o]) => ({
    ...n,
    [r]: async (...s) => await t(o(...s))
  }),
  {}
), Sn = (e, t, n, r, o) => {
  r === void 0 && (r = {});
  const s = z(), c = rt(e, n, o);
  return {
    name: e,
    reducer: c,
    initialState: t,
    attach: (u, f) => ({
      name: e,
      state: u,
      ...ct(e, n, u, f),
      ...it(r, f)
    }),
    maybeProvider: s
  };
}, ar = (e, t) => function(...n) {
  return async function(r) {
    r({ type: `${e}/setStatus`, payload: "busy" });
    try {
      const o = await t(...n);
      return r({ type: `${e}/setData`, payload: o }), o;
    } catch (o) {
      throw r({ type: `${e}/setError`, payload: o }), o;
    } finally {
      r({ type: `${e}/setStatus`, payload: "idle" });
    }
  };
}, lr = (e, t) => (n) => ({
  setStatus: (r) => ({ ...n, status: r }),
  setError: (r) => ({ ...n, error: r }),
  setData: (r) => ({ ...n, ...r }),
  reset: () => ({ status: "idle", error: null, ...e }),
  clearError: () => ({ ...n, error: null }),
  ...t(n)
}), gn = (e, t) => (n) => ({
  setStatus: (r) => ({ ...n, status: r }),
  setError: (r) => ({ ...n, error: r }),
  setData: (r) => ({ ...n, ...r }),
  reset: () => ot(e),
  clearError: () => ({ ...n, error: null }),
  ...t(n)
}), mn = (e, t) => (...n) => async (r) => {
  r({ type: `${e}/setStatus`, payload: "busy" });
  try {
    const o = await t(...n);
    return r({ type: `${e}/setData`, payload: o }), o;
  } catch (o) {
    throw r({ type: `${e}/setError`, payload: o }), o;
  } finally {
    r({ type: `${e}/setStatus`, payload: "idle" });
  }
}, En = (e, t) => Object.entries(t).reduce(
  (n, [r, o]) => ({
    ...n,
    [r]: mn(e, o)
  }),
  {}
), fr = ({
  name: e,
  initialState: t,
  mutations: n,
  asyncMethods: r,
  middleware: o
}) => {
  n === void 0 && (n = (u) => ({})), r === void 0 && (r = {});
  const s = ot(t), c = gn(t, n), i = En(e, r);
  return Sn(e, s, c, i, o);
}, _n = (e) => (t) => ({
  select: (n) => ({ ...t, selected: n }),
  reset: () => e,
  clearError: () => ({ ...t, error: null })
}), wn = (e) => ({
  upsertMany: (t) => (...n) => async (r) => {
    r({ type: e.RequestStart });
    try {
      const { objects: o, meta: s } = await t(...n);
      return r({ type: e.FetchCollectionSuccess, payload: o }), s && r({ type: e.UpdateMeta, payload: s }), o;
    } catch (o) {
      throw r({ type: e.RequestError, payload: o }), o;
    }
  },
  upsertOne: (t) => (...n) => async (r) => {
    try {
      const o = await t(...n);
      return r({ type: e.CreateModelSuccess, payload: o }), o;
    } catch (o) {
      throw r({ type: e.RequestError, payload: o }), o;
    }
  },
  deleteOne: (t) => (...n) => async (r) => {
    r({ type: e.RequestStart });
    try {
      const o = await t(...n);
      return r({ type: e.DeleteModelSuccess, payload: o }), o;
    } catch (o) {
      throw r({ type: e.RequestError, payload: o }), o;
    }
  }
}), dr = ({
  name: e,
  initialState: t,
  mutations: n,
  asyncMethods: r
}) => {
  const o = L(
    rn(r),
    nn(() => () => ({}))
  ), s = z(), c = st(e), i = _n(t), u = pn(e, t, n), f = rt(e, i), l = (d, h) => [u, f].reduce((p, A) => A(p, h), d), a = wn(c);
  return {
    name: e,
    reducer: l,
    initialState: t,
    attach: (d, h) => ({
      name: e,
      state: d,
      ...ct(e, i, d, h),
      ...it(o(a), h)
    }),
    maybeProvider: s
  };
}, ut = (e, t, n) => {
  let r;
  const o = Fe(t);
  o.displayName = `${e} context`;
  const s = (u, f) => gt(o.Provider, u, f);
  return [() => {
    const u = St(o);
    if (u == null)
      throw new Error("createStore must be used inside a Provider.");
    return [u, r];
  }, ({ children: u }) => {
    const [f, l] = ge(t, n);
    return r = l, s({ value: f }, u);
  }];
}, On = (e) => {
  const [t, n] = ut(
    e.name,
    e.initialState,
    e.reducer
  );
  return e.maybeProvider = Y(t), [t, n];
}, bn = (e, ...t) => {
  const n = t.reduce(
    (c, i) => ({
      ...c,
      [i.name]: i.initialState
    }),
    {}
  ), r = (c, i) => t.reduce(
    (u, f) => ({
      ...u,
      [f.name]: f.reducer(c[f.name], i)
    }),
    c
  ), [o, s] = ut(e, n, r);
  return t.forEach((c) => {
    c.maybeProvider = Y(() => {
      const [i, u] = o();
      return [i[c.name], u];
    });
  }), [o, s];
};
function hr(e, ...t) {
  return typeof e == "string" ? bn(e, ...t) : On(e);
}
const yr = (e, t) => {
  const n = localStorage.getItem(`@store:${e}`), r = n && JSON.parse(n) || {};
  return { ...t, ...r };
}, pr = (e, t) => ({
  text: () => new Promise((n) => n(JSON.stringify(e))),
  headers: { get: (n) => t.contentType ?? "" },
  ok: t.shouldSucceed ?? !0
}), Rn = 0, vn = 1, Tn = 2;
var $e = Object.prototype.hasOwnProperty;
function se(e, t) {
  var n, r;
  if (e === t)
    return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date)
      return e.getTime() === t.getTime();
    if (n === RegExp)
      return e.toString() === t.toString();
    if (n === Array) {
      if ((r = e.length) === t.length)
        for (; r-- && se(e[r], t[r]); )
          ;
      return r === -1;
    }
    if (!n || typeof e == "object") {
      r = 0;
      for (n in e)
        if ($e.call(e, n) && ++r && !$e.call(t, n) || !(n in t) || !se(e[n], t[n]))
          return !1;
      return Object.keys(t).length === r;
    }
  }
  return e !== e && t !== t;
}
const j = /* @__PURE__ */ new WeakMap(), T = () => {
}, m = (
  /*#__NOINLINE__*/
  T()
), ce = Object, w = (e) => e === m, N = (e) => typeof e == "function", Z = (e, t) => ({
  ...e,
  ...t
}), Cn = (e) => N(e.then), te = {}, V = {}, at = "undefined", me = typeof window != at, ie = typeof document != at, jn = me && "Deno" in window, Nn = (e, t) => {
  const n = j.get(e);
  return [
    // Getter
    () => !w(t) && e.get(t) || te,
    // Setter
    (r) => {
      if (!w(t)) {
        const o = e.get(t);
        t in V || (V[t] = o), n[5](t, Z(o, r), o || te);
      }
    },
    // Subscriber
    n[6],
    // Get server cache snapshot
    () => !w(t) && t in V ? V[t] : !w(t) && e.get(t) || te
  ];
};
let ue = !0;
const Mn = () => ue, [ae, le] = me && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  T,
  T
], Pn = () => {
  const e = ie && document.visibilityState;
  return w(e) || e !== "hidden";
}, In = (e) => (ie && document.addEventListener("visibilitychange", e), ae("focus", e), () => {
  ie && document.removeEventListener("visibilitychange", e), le("focus", e);
}), $n = (e) => {
  const t = () => {
    ue = !0, e();
  }, n = () => {
    ue = !1;
  };
  return ae("online", t), ae("offline", n), () => {
    le("online", t), le("offline", n);
  };
}, Dn = {
  isOnline: Mn,
  isVisible: Pn
}, An = {
  initFocus: In,
  initReconnect: $n
};
yt.useId;
const lt = !me || jn, ne = typeof navigator < "u" && navigator.connection, De = !lt && ne && ([
  "slow-2g",
  "2g"
].includes(ne.effectiveType) || ne.saveData), B = /* @__PURE__ */ new WeakMap(), re = (e, t) => ce.prototype.toString.call(e) === `[object ${t}]`;
let kn = 0;
const fe = (e) => {
  const t = typeof e, n = re(e, "Date"), r = re(e, "RegExp"), o = re(e, "Object");
  let s, c;
  if (ce(e) === e && !n && !r) {
    if (s = B.get(e), s)
      return s;
    if (s = ++kn + "~", B.set(e, s), Array.isArray(e)) {
      for (s = "@", c = 0; c < e.length; c++)
        s += fe(e[c]) + ",";
      B.set(e, s);
    }
    if (o) {
      s = "#";
      const i = ce.keys(e).sort();
      for (; !w(c = i.pop()); )
        w(e[c]) || (s += c + ":" + fe(e[c]) + ",");
      B.set(e, s);
    }
  } else
    s = n ? e.toJSON() : t == "symbol" ? e.toString() : t == "string" ? JSON.stringify(e) : "" + e;
  return s;
}, xn = (e) => {
  if (N(e))
    try {
      e = e();
    } catch {
      e = "";
    }
  const t = e;
  return e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? fe(e) : "", [
    e,
    t
  ];
};
let Fn = 0;
const Ae = () => ++Fn;
async function qn(...e) {
  const [t, n, r, o] = e, s = Z({
    populateCache: !0,
    throwOnError: !0
  }, typeof o == "boolean" ? {
    revalidate: o
  } : o || {});
  let c = s.populateCache;
  const i = s.rollbackOnError;
  let u = s.optimisticData;
  const f = (y) => typeof i == "function" ? i(y) : i !== !1, l = s.throwOnError;
  if (N(n)) {
    const y = n, d = [], h = t.keys();
    for (const p of h)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(p) && y(t.get(p)._k) && d.push(p);
    return Promise.all(d.map(a));
  }
  return a(n);
  async function a(y) {
    const [d] = xn(y);
    if (!d)
      return;
    const [h, p] = Nn(t, d), [A, E, U, C] = j.get(t), k = () => {
      const b = A[d];
      return (N(s.revalidate) ? s.revalidate(h().data, y) : s.revalidate !== !1) && (delete U[d], delete C[d], b && b[0]) ? b[0](Tn).then(() => h().data) : h().data;
    };
    if (e.length < 3)
      return k();
    let S = r, O;
    const Ee = Ae();
    E[d] = [
      Ee,
      0
    ];
    const _e = !w(u), we = h(), Oe = we.data, be = we._c, x = w(be) ? Oe : be;
    if (_e && (u = N(u) ? u(x, Oe) : u, p({
      data: u,
      _c: x
    })), N(S))
      try {
        S = S(x);
      } catch (b) {
        O = b;
      }
    if (S && Cn(S))
      if (S = await S.catch((b) => {
        O = b;
      }), Ee !== E[d][0]) {
        if (O)
          throw O;
        return S;
      } else
        O && _e && f(O) && (c = !0, p({
          data: x,
          _c: m
        }));
    if (c && !O)
      if (N(c)) {
        const b = c(S, x);
        p({
          data: b,
          error: m,
          _c: m
        });
      } else
        p({
          data: S,
          error: m,
          _c: m
        });
    if (E[d][1] = Ae(), Promise.resolve(k()).then(() => {
      p({
        _c: m
      });
    }), O) {
      if (l)
        throw O;
      return;
    }
    return S;
  }
}
const ke = (e, t) => {
  for (const n in e)
    e[n][0] && e[n][0](t);
}, Jn = (e, t) => {
  if (!j.has(e)) {
    const n = Z(An, t), r = {}, o = qn.bind(m, e);
    let s = T;
    const c = {}, i = (l, a) => {
      const y = c[l] || [];
      return c[l] = y, y.push(a), () => y.splice(y.indexOf(a), 1);
    }, u = (l, a, y) => {
      e.set(l, a);
      const d = c[l];
      if (d)
        for (const h of d)
          h(a, y);
    }, f = () => {
      if (!j.has(e) && (j.set(e, [
        r,
        {},
        {},
        {},
        o,
        u,
        i
      ]), !lt)) {
        const l = n.initFocus(setTimeout.bind(m, ke.bind(m, r, Rn))), a = n.initReconnect(setTimeout.bind(m, ke.bind(m, r, vn)));
        s = () => {
          l && l(), a && a(), j.delete(e);
        };
      }
    };
    return f(), [
      e,
      o,
      f,
      s
    ];
  }
  return [
    e,
    j.get(e)[4]
  ];
}, Un = (e, t, n, r, o) => {
  const s = n.errorRetryCount, c = o.retryCount, i = ~~((Math.random() + 0.5) * (1 << (c < 8 ? c : 8))) * n.errorRetryInterval;
  !w(s) && c > s || setTimeout(r, i, o);
}, Vn = se, [Bn, _] = Jn(/* @__PURE__ */ new Map());
Z(
  {
    // events
    onLoadingSlow: T,
    onSuccess: T,
    onError: T,
    onErrorRetry: Un,
    onDiscarded: T,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: De ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: De ? 5e3 : 3e3,
    // providers
    compare: Vn,
    isPaused: () => !1,
    cache: Bn,
    mutate: _,
    fallback: {}
  },
  // use web preset by default
  Dn
);
Fe({});
const Ln = () => localStorage.getItem("token"), Sr = (e) => localStorage.setItem("token", e);
function ft(e, t, n) {
  let r = e;
  if (t && Object.keys(t).length > 0) {
    r += ":";
    const o = Object.entries(t).map(([s, c]) => `_${s}_${c}`).join("");
    r += o;
  }
  if (n && Object.keys(n).length > 0) {
    r += "?";
    const o = Object.entries(n).map(([s, c]) => `_${s}_${c}`).join("");
    r += o;
  }
  return r;
}
const Gn = /^https?:\/\//i;
class xe extends Error {
  constructor(n) {
    super("Server returned an error");
    P(this, "code");
    P(this, "messages");
    this.code = n.code, this.messages = n.messages;
  }
}
const Wn = (e, t = {}) => {
  let n = e;
  const { pathParams: r, queryParams: o } = t;
  return r && Object.keys(r).forEach((c) => {
    n = n.replace(`{${c}}`, r[c].toString());
  }), o && (n = `${n}?${o ? new URLSearchParams(o).toString() : ""}`), n;
}, gr = (e, t) => async (n, r) => {
  if (!Gn.test(e))
    throw new Error("Invalid path");
  try {
    const o = Ln(), s = Wn(e, r), c = new Request(s, {
      ...t,
      body: n && (n instanceof FormData ? n : JSON.stringify(n)),
      headers: {
        Accept: "application/json, text/plain, */*",
        "content-type": "application/json;charset=utf-8",
        ...t.useAuthorization && o && { Authorization: `Bearer ${o}` },
        ...t.headers
      }
    });
    let i;
    if (t.cacheId && (i = ft(t.cacheId, r == null ? void 0 : r.pathParams, r == null ? void 0 : r.queryParams), c.method === "GET")) {
      const y = await _(i);
      if (y)
        return {
          data: y,
          statusCode: 200
        };
    }
    const u = await fetch(c);
    if (u.headers.get("content-type") === "application/octet-stream")
      return {
        data: await u.blob(),
        statusCode: u.status
      };
    if (u.headers.get("content-type") === "text/csv")
      return {
        data: await u.blob(),
        statusCode: u.status
      };
    const f = await u.text();
    let l = f === "" ? {} : JSON.parse(f);
    if (!u.ok)
      throw l.code = u.status, new xe(l);
    if (t.validation) {
      const { validation: y } = t, d = y.responseSchema.safeParse(l);
      if (d.success)
        l = d.data;
      else
        throw new Error(d.error.toString());
    }
    let a = 0;
    return t.cacheId && (c.method === "GET" ? (a === 1 && (i != null && i.includes("years")) ? (console.log("invalidate"), _(i, void 0, { revalidate: !1 }), console.log("done")) : await _(i, l, { revalidate: !1 }), i != null && i.includes("years") && (a += 1)) : await _(i, void 0, { revalidate: !1 })), {
      data: l,
      statusCode: u.status
    };
  } catch (o) {
    throw o instanceof xe ? o : new Error(o.message);
  }
}, Hn = (e) => "code" in e && "messages" in e, zn = (e, t) => e.replace(/\${(.*?)}/g, (n, r) => t[r]), Yn = ({
  method: e,
  urlTemplate: t,
  validations: n,
  useAuthorization: r = !1,
  baseUrlOverride: o = void 0,
  defaultHeaders: s,
  cacheId: c
}) => async (i) => {
  var y, d;
  const u = o || X().baseUrl;
  if (!u)
    return D({
      code: 400,
      messages: [{ code: "BASE_URL_NOT_DEFINED", message: "Base URL not defined" }]
    });
  if (!X().getToken)
    return D({
      code: 400,
      messages: [{ code: "GET_TOKEN_NOT_DEFINED", message: "getToken method was not defined in config" }]
    });
  const f = "urlParams" in i ? zn(t, i.urlParams) : t, l = new URL(f, u);
  l.search = "query" in i && i.query ? new URLSearchParams(i.query).toString() : "";
  let a;
  if (c && (a = ft(
    c,
    "urlParams" in i ? i.urlParams : void 0,
    "query" in i && i.query ? Object.fromEntries(i.query.entries()) : void 0
  ), e === "GET")) {
    const h = await _(a);
    if (h)
      return ee({
        data: h,
        statusCode: 200
      });
  }
  try {
    const h = await ((d = (y = X()).getToken) == null ? void 0 : d.call(y)), p = "payload" in i ? i.payload : void 0;
    if (p && (n != null && n.request)) {
      const S = n.request.safeParse(p);
      if (!S.success)
        throw S.error;
    }
    const A = new Request(l.toString(), {
      method: e,
      body: p && !(p instanceof FormData) ? JSON.stringify(p) : p,
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": p instanceof FormData ? "" : "application/json;charset=utf-8",
        ...s,
        ...r && h && { Authorization: `Bearer ${h}` }
      }
    }), E = await fetch(A);
    if (E.headers.get("content-type") === "application/octet-stream") {
      const S = await E.blob();
      return c && (e === "GET" ? await _(a, S, { revalidate: !1 }) : await _(a, void 0, !1)), ee({
        data: S,
        statusCode: E.status
      });
    }
    const U = await E.text();
    let C = U === "" ? {} : JSON.parse(U);
    if (!E.ok)
      return D({
        code: E.status,
        messages: [C]
      });
    n != null && n.response && (C = n.response.parse(C));
    let k = 0;
    return c && (e === "GET" ? (k === 1 && (a != null && a.includes("years")) ? (console.log("invalidate"), _(a, void 0, { revalidate: !1 }), console.log("done")) : await _(a, C, { revalidate: !1 }), a != null && a.includes("years") && k++) : _(a, void 0, { revalidate: !1 })), ee({
      data: C,
      statusCode: E.status
    });
  } catch (h) {
    return h instanceof _t ? D({
      code: 400,
      messages: [{ code: "ZOD_ERROR", message: h.message }]
    }) : Hn(h) ? D(h) : D({
      code: 500,
      messages: [{ code: "SERVER_ERROR", message: h.message }]
    });
  }
}, mr = (e) => L(Yn(e), (t) => {
  const n = t;
  return n.urlTemplate = () => e.urlTemplate, n.method = () => e.method, t;
});
function Er(e, t) {
  const [n, r] = mt(e);
  return Et(() => {
    const o = setTimeout(() => r(e), t || 500);
    return () => {
      clearTimeout(o);
    };
  }, [e, t]), n;
}
const _r = (e) => {
  const [t, n] = nt(e.maybeProvider, {
    onNone: () => ge(e.initialState, e.reducer),
    onSome: (r) => r()
  });
  return e.attach(t, n);
}, Zn = (e) => ({
  first: () => e.entities[e.keys[0]],
  get: (t) => e.entities[t] || null,
  items: Object.values(e.entities),
  map: (t) => e.keys.map((n, r) => t(e.entities[n], r)),
  filter: (t) => Object.values(e.entities).filter((n) => t(n)),
  sort: (t, n) => Object.values(e.entities).sort((r, o) => {
    if (typeof t == "function")
      return t(r, o);
    const s = je(r, t), c = je(o, t);
    return (s > c ? 1 : s < c ? -1 : 0) * (n ? -1 : 1);
  }),
  isEmpty: e.keys.length === 0,
  isBusy: e.status === "busy",
  getSelected: () => e.selected && e.selected in e.entities ? e.entities[e.selected] : null,
  count: e.keys.length
}), wr = (e) => {
  const [t, n] = nt(e.maybeProvider, {
    onNone: () => ge(e.initialState, e.reducer),
    onSome: (r) => r()
  });
  return { ...e.attach(t, n), ...Zn(t) };
};
export {
  xe as ApiError,
  W as PK,
  cn as arrayToMap,
  ir as composeMiddleware,
  sn as consoleMiddleware,
  dr as createCollection,
  gr as createEndpoint,
  mr as createEndpointV2,
  pr as createMockedFetchResponse,
  hr as createProvider,
  ge as createReducer,
  fr as createResource,
  lr as createResourceMutations,
  ar as createResourceThunk,
  Sn as createStore,
  sr as createThunk,
  je as get,
  ft as getCacheId,
  X as getConfig,
  Ln as getToken,
  ur as initCollection,
  ot as initResource,
  Hn as isApiError,
  nr as isEmpty,
  yr as loadStateFromLocalStorage,
  cr as localStorageMiddleware,
  or as maybeModel,
  rr as omit,
  tr as setConfig,
  Sr as setToken,
  wr as useCollection,
  Er as useDebounce,
  _r as useStore
};
//# sourceMappingURL=index.es.js.map
